import { render, staticRenderFns } from "./setUpPage.vue?vue&type=template&id=3f435413&scoped=true&"
import script from "./setUpPage.vue?vue&type=script&lang=js&"
export * from "./setUpPage.vue?vue&type=script&lang=js&"
import style0 from "./setUpPage.vue?vue&type=style&index=0&id=3f435413&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f435413",
  null
  
)

export default component.exports